import { Header as BronsonReactHeader, Logo } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";

export const Header = () => {
    const { t } = useTranslation();
    const brand = process.env.REACT_APP_WEBSITE_BRAND;
    return (
        <BronsonReactHeader
            staticHeader
            logo={
                <Logo
                    title={`${brand} logo`}
                    aria-hidden="true"
                    disableLink
                    // onClick={() => {
                        // adobeDataLayer.interactionLogoClicked();
                        // // we cannot use navigate method here as we are using hash routing in this app
                        // // but here we need to redirect user to a Landing page which created on AEM.
                        // window.open(
                        //     RouterHelpers.getLandingPageUrl(state.legalEntity === "004180" ? "leasing" : "financing"),
                        //     "_self"
                        // );
                    // }}
                />
            }
        />
    );
};

export default Header;
